"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = require('@angular/core');
var common_1 = require('@angular/common');
var datepicker_1 = require('./datepicker');
var datepicker_month_view_1 = require('./datepicker-month-view');
var datepicker_navigation_1 = require('./datepicker-navigation');
var datepicker_input_1 = require('./datepicker-input');
var forms_1 = require('@angular/forms');
var datepicker_day_view_1 = require('./datepicker-day-view');
var datepicker_i18n_1 = require('./datepicker-i18n');
var ngb_calendar_1 = require('./ngb-calendar');
var ngb_date_parser_formatter_1 = require('./ngb-date-parser-formatter');
var datepicker_service_1 = require('./datepicker-service');
var datepicker_navigation_select_1 = require('./datepicker-navigation-select');
var datepicker_config_1 = require('./datepicker-config');
var datepicker_2 = require('./datepicker');
exports.NgbDatepicker = datepicker_2.NgbDatepicker;
var datepicker_input_2 = require('./datepicker-input');
exports.NgbInputDatepicker = datepicker_input_2.NgbInputDatepicker;
var datepicker_month_view_2 = require('./datepicker-month-view');
exports.NgbDatepickerMonthView = datepicker_month_view_2.NgbDatepickerMonthView;
var datepicker_day_view_2 = require('./datepicker-day-view');
exports.NgbDatepickerDayView = datepicker_day_view_2.NgbDatepickerDayView;
var datepicker_navigation_2 = require('./datepicker-navigation');
exports.NgbDatepickerNavigation = datepicker_navigation_2.NgbDatepickerNavigation;
var datepicker_navigation_select_2 = require('./datepicker-navigation-select');
exports.NgbDatepickerNavigationSelect = datepicker_navigation_select_2.NgbDatepickerNavigationSelect;
var datepicker_config_2 = require('./datepicker-config');
exports.NgbDatepickerConfig = datepicker_config_2.NgbDatepickerConfig;
var datepicker_i18n_2 = require('./datepicker-i18n');
exports.NgbDatepickerI18n = datepicker_i18n_2.NgbDatepickerI18n;
var ngb_date_parser_formatter_2 = require('./ngb-date-parser-formatter');
exports.NgbDateParserFormatter = ngb_date_parser_formatter_2.NgbDateParserFormatter;
var NgbDatepickerModule = (function () {
    function NgbDatepickerModule() {
    }
    NgbDatepickerModule.forRoot = function () {
        return {
            ngModule: NgbDatepickerModule,
            providers: [
                { provide: ngb_calendar_1.NgbCalendar, useClass: ngb_calendar_1.NgbCalendarGregorian },
                { provide: datepicker_i18n_1.NgbDatepickerI18n, useClass: datepicker_i18n_1.NgbDatepickerI18nDefault },
                { provide: ngb_date_parser_formatter_1.NgbDateParserFormatter, useClass: ngb_date_parser_formatter_1.NgbDateISOParserFormatter }, datepicker_service_1.NgbDatepickerService,
                datepicker_config_1.NgbDatepickerConfig
            ]
        };
    };
    NgbDatepickerModule = __decorate([
        core_1.NgModule({
            declarations: [
                datepicker_1.NgbDatepicker, datepicker_month_view_1.NgbDatepickerMonthView, datepicker_navigation_1.NgbDatepickerNavigation, datepicker_navigation_select_1.NgbDatepickerNavigationSelect, datepicker_day_view_1.NgbDatepickerDayView,
                datepicker_input_1.NgbInputDatepicker
            ],
            exports: [datepicker_1.NgbDatepicker, datepicker_input_1.NgbInputDatepicker],
            imports: [common_1.CommonModule, forms_1.FormsModule],
            entryComponents: [datepicker_1.NgbDatepicker]
        }), 
        __metadata('design:paramtypes', [])
    ], NgbDatepickerModule);
    return NgbDatepickerModule;
}());
exports.NgbDatepickerModule = NgbDatepickerModule;
//# sourceMappingURL=datepicker.module.js.map


//////////////////
// WEBPACK FOOTER
// ./temp/datepicker/datepicker.module.js
// module id = 14
// module chunks = 0